// TODO use/update models
import { CrudState } from "@/store/modules/crud/State";
import IRegion from "@/models/IRegion";

export class State extends CrudState {
  dataList: Array<IRegion> = [];
  dataItem: IRegion | null = null;
}
